import { BerthResponseDto } from '@planning/app/api'
import { EventTypes } from '@planning/messages/eventsTypes'
import { GetBerthsQuery } from '@planning/messages/queries'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import _ from 'lodash'
import { action, computed, makeObservable } from 'mobx'
import { ItemStore } from '../base/ItemStore'
import { IEntityStore } from '../types'
import { BerthItem, IBerthItem } from './BerthItem'
import { PierItemStore } from './PierItemStore'

export class BerthItemStore
  extends ItemStore<BerthResponseDto, IBerthItem>
  implements IEntityStore<IBerthItem>
{
  private hasBeenLoaded = false

  constructor(
    private messageBus: IMessageBus,
    private pierItemStore: PierItemStore,
  ) {
    super((key, data) => new BerthItem(key, data, this.pierItemStore))
    makeObservable(this, {
      berthsByPier: computed,
      piersIds: computed,

      receiveBerthsMessage: action,
      receiveBerthUpsertedEventMessage: action,
      receiveBerthDeletedEventMessage: action,
    })

    messageBus.subscribeEvent(GetBerthsQuery.type, this.receiveBerthsMessage)
    messageBus.subscribeEvent(EventTypes.BerthUpsertedEvent, this.receiveBerthUpsertedEventMessage)
    messageBus.subscribeEvent(EventTypes.BerthDeletedEvent, this.receiveBerthDeletedEventMessage)
  }

  fetch = async () => {
    if (this.hasBeenLoaded) return

    this.hasBeenLoaded = true

    await this.messageBus.dispatchQuery(new GetBerthsQuery())
  }

  get berthsByPier() {
    return _(this.elements)
      .filter(x => !x.data.isDeleted)
      .orderBy(b => b.data.quayMeterMarkFrom)
      .groupBy(berth => berth.data.pierId)
      .value()
  }

  get piersIds() {
    return _(this.elements)
      .filter(x => !x.data.isDeleted)
      .map(berth => berth.data.pierId)
      .uniq()
      .value()
  }

  getBerthsByPier(pier: string) {
    return (
      _(this.berthsByPier[pier])
        ?.map(b => b.data)
        .value() ?? []
    )
  }

  receiveBerthsMessage = (event: IEvent<BerthResponseDto[]>): void => {
    if (event.payload) {
      this.upsertBulk(event.payload)
    }
  }

  receiveBerthUpsertedEventMessage = (event: IEvent<BerthResponseDto>) => {
    if (event.payload) {
      this.upsert(event.payload)
    }
  }

  receiveBerthDeletedEventMessage = (event: IEvent<number>) => {
    if (event.payload) {
      this.delete(event.payload)
    }
  }
}
